import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import { GdprNoticeService } from '../../services/gdpr-notice.service';
import * as GdprNoticeActions from './gdprNotice.actions';

@Injectable()
export class GdprNoticeEffects {

  constructor(
    private actions$: Actions,
    private gdprNoticeService: GdprNoticeService
  ) {}

  checkToken$ = createEffect(() => this.actions$.pipe(
    ofType(GdprNoticeActions.checkToken),
    tap(action => console.log('Checking token:', action.token)),
    mergeMap(action => this.gdprNoticeService.validateToken(action.token)
      .pipe(
        map(data => {
          console.log('Token validation success:', data);
          return GdprNoticeActions.checkTokenSuccess({ data });
        }),
        catchError(error => {
          console.error('Token validation error:', error);
          return of(GdprNoticeActions.checkTokenFailure({ error }));
        })
      )
    )
  ));

  optOut$ = createEffect(() => this.actions$.pipe(
    ofType(GdprNoticeActions.optOut),
    tap(action => console.log('Opt out:', action.token)),
    mergeMap(action => this.gdprNoticeService.optOut(action.token)
      .pipe(
        map(data => {
          console.log('Out out success:', data);
          return GdprNoticeActions.optOutSuccess({ data });
        }),
        catchError(error => {
          console.error('Out out failed:', error);
          return of(GdprNoticeActions.optOutFailure({ error }));
        })
      )
    )
  ));

}
